import './style.scss';
import mountFlyoutFeature from './container/Flyout/index';

mountFlyoutFeature();
